import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Layout, Button, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { ImageUrl } from "../../helpers/Functions";
import "./b2b-training.css";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const videoRef = useRef(null);

  const [modal2Open, setModal2Open] = useState(false);

  useEffect(() => {
    if (modal2Open && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    }
  }, [modal2Open]);

  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  const data2 = [
    {
      title: "Enroll teams into training with group enrollment codes.",
    },
    {
      title: "Upload 1000s of users into a training portal in one step.",
    },
    {
      title:
        "Simultaneously enroll users into various courses while onboarding them into the system.",
    },
  ];

  const data3 = [
    {
      title: "Manage Training Engagement",
      des: "Completion statuses, Certifications, Assignment scores, and more.",
    },
    {
      title: "Oversee Course Enrollment",
      des: "Number of active Users, Enrollment date, Last-active date.",
    },
    {
      title: "Report On Certifications And More...",
      des: "Track Certification statuses and review assignment submissions—then provide feedback.",
    },
  ];

  const data4 = [
    {
      title: "Sell Course Licenses In Bulk",
      des: "and charge organizations with a one-time payment or a subscription model.",
    },
    {
      title: "Offer Discounts Using Coupon Codes",
      des: "Number of active Users, Enrollment date, Last-active date.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Safety Training for Educators & Staff - Virtual B2B Health Training
        </title>
        <meta
          name="description"
          content="Enroll in virtual health and safety training for educators, including virtual sessions tailored for early education staff. Enhance your team with WrightCo Academy"
        />
        <meta
          property="og:title"
          content="Safety Training for Educators & Staff - Virtual B2B Health Training"
        />
        <meta
          property="og:description"
          content="Enroll in virtual health and safety training for educators, including virtual sessions tailored for early education staff. Enhance your team with WrightCo Academy"
        />
      </Helmet>

      <Layout className="b2b-page">
        <section
          className="b2b-hero"
          style={{ backgroundImage: `url(${ImageUrl("new-51.png")})` }}
        >
          <div className="b2b-hero-overlay" aria-hidden />
          <div className="b2b-wrap b2b-hero-inner">
            <div className="b2b-hero-copy">
              <span className="b2b-hero-badge">LMS FOR B2B TRAINING</span>
              <h1 className="fontFamily1 b2b-hero-title">
                We Train Individuals and <span>Organizations At Scale</span>
              </h1>
              <p className="fontFamily1 b2b-hero-sub">
                Administer and scale your training with our user-friendly
                platform. Manage on-demand and instructor-led courses with
                WrightCo Academy.
              </p>
              <div className="b2b-hero-actions">
                {!token && (
                  <Button
                    type="primary"
                    className="b2b-hero-btn-primary"
                    onClick={() => window.open("/signup", "_blank")}
                  >
                    Register Now
                  </Button>
                )}
                <Button
                  className="b2b-hero-btn-outline"
                  onClick={() => setModal2Open(true)}
                >
                  See The Platform <FaArrowRight />
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg4.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Track your Customers&apos; Progress with Learner Reports
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                After onboarding a user, administrators can keep track of their
                progress and engagement using different reports.
              </p>
            </div>

            <div className="b2b-cards">
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-34.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Review Assignments and Give Feedback</h3>
                  <p>
                    Review assignment submissions, provide feedback, and give
                    grades directly inside of the LMS.
                  </p>
                </div>
              </article>
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-35.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Track Completions - Scores - Time-Spent</h3>
                  <p>
                    When selling courses directly on our software, you can use
                    your logo and brand colors throughout the site.
                  </p>
                </div>
              </article>
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-36.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Keep Track Of Learner Progress</h3>
                  <p>
                    Customers can report on learner progress in their portal by
                    looking at an individual or a group of learners.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--white">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg2.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">Swift Enrollment of Users</h2>
                <p>
                  Enroll employees into on-boarding training courses quickly.
                  WrightCo Academy is a practical solution for both small and
                  large organizations.
                </p>
                <ul className="b2b-check-list">
                  {data2.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
              <div className="b2b-split-media">
                <img src={ImageUrl("new-53.png")} alt="" loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-split b2b-split--reverse">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-38.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg4.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">Organize Internal Training</h2>
                <p>
                  Organize your internal training by creating separate portals
                  for each department. Training portals can be managed by team
                  leaders.
                </p>
                <ul className="b2b-check-list">
                  {data3.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>
                        <strong>{item.title}</strong>
                        {item.des ? ` — ${item.des}` : ""}
                      </span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--navy">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg2.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Report On Learning Progress With WrightCo Academy
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Each organization manages its own program by assigning an admin
                to its portal. Admins can report on completion statuses,
                assessment scores, certifications, and more.
              </p>
              {!token && (
                <div className="b2b-cta-center">
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                </div>
              )}
            </div>

            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-54.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <ul className="b2b-feature-list">
                  {data3.map((item) => (
                    <li key={`report-${item.title}`}>
                      <span className="b2b-feature-icon" aria-hidden>
                        <FaCheckCircle />
                      </span>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.des}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--navy">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg2.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Sell Training Directly On The LMS
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Fully customize the menus, buttons, and text sections in the LMS
                to better represent your company and training type.
              </p>
              {!token && (
                <div className="b2b-cta-center">
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                </div>
              )}
            </div>

            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-28.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <ul className="b2b-feature-list">
                  {data4.map((item) => (
                    <li key={item.title}>
                      <span className="b2b-feature-icon" aria-hidden>
                        <FaCheckCircle />
                      </span>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.des}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-trainer">
          <div className="b2b-wrap">
            <div className="b2b-trainer-card">
              <h3>We&apos;re Looking for Trainers</h3>
              <h3>Teach. Create. Earn.</h3>
              <p>
                Are you passionate about teaching? Ready to share your expertise,
                connect with professionals, and make a meaningful impact, all
                while earning extra income?
              </p>

              <h4>You&apos;ve come to the right place.</h4>
              <p>
                At WrightCo Academy, we are building a network of world-class
                trainers and industry experts dedicated to developing
                high-quality courseware for professionals in early care and
                education. If you&apos;re an expert in your field with a desire
                to teach, we&apos;d love to have you on board!
              </p>

              <h3>Why Join Us?</h3>
              <ul>
                <li>
                  <p>
                    ✅ Expand Your Reach – Share your knowledge with a broad
                    audience of professionals.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Boost Your Visibility – Gain recognition as a trusted
                    expert in your industry.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Join a Thriving Community – Connect with like-minded
                    trainers and industry leaders.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Earn Passive Income – Our fair and flexible revenue-sharing
                    model ensures unlimited earning potential.
                  </p>
                </li>
              </ul>

              <h3>What It Takes to Be a WrightCo Trainer</h3>
              <ul>
                <li>
                  <p>
                    ✔ <strong>Passion for Teaching</strong> – A commitment to
                    sharing knowledge and empowering others.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Industry Expertise</strong> – Relevant
                    certifications and experience in your domain.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Strong Communication Skills</strong> – Ability to
                    present information effectively.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Commitment to Excellence</strong> – Willingness to
                    develop and deliver high-quality training.
                  </p>
                </li>
              </ul>

              <h4>Ready to Make an Impact?</h4>
              <p>
                Join WrightCo Academy today and take the next step in your
                teaching journey.
              </p>
              <Button
                className="b2b-trainer-btn"
                onClick={() => window.open("/signup", "_blank")}
                size="large"
              >
                Register Now
              </Button>
            </div>
          </div>
        </section>

        <Modal
          className="b2b-video-modal"
          centered
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
          width={1000}
          footer={false}
        >
          <div style={{ padding: "24px 12px" }}>
            <video width="auto" height="auto" ref={videoRef} controls>
              <source
                src="https://react.customdev.solutions/wrightco_uploads/b2b-video.mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Modal>
      </Layout>
    </>
  );
}

export default Homepage;
